import { render, staticRenderFns } from "./HeatmapLegend.vue?vue&type=template&id=574dd076"
import script from "./HeatmapLegend.vue?vue&type=script&lang=js"
export * from "./HeatmapLegend.vue?vue&type=script&lang=js"
import style0 from "./HeatmapLegend.vue?vue&type=style&index=0&id=574dd076&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports